import Hoverable from 'components/Hoverable'
import { View } from 'components/View'
import React from 'react'

export function ListRowItem (props) {
  return (
    <Hoverable>
      <article>
        <View {...props} />
      </article>
    </Hoverable>
  )
}
